import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { IftaLabelModule } from 'primeng/iftalabel';
import { SelectModule } from 'primeng/select';
import { CrmClient, CrmClientCommunication } from '../../crm/crm.model';

@Component({
    selector: 'app-crm-client-contact-picker',
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        SelectModule,
        InputGroupModule,
        InputGroupAddonModule,
        IftaLabelModule
    ],
    template: `
        <div class="field">
            <p-inputGroup>
                <p-inputGroupAddon><i class="pi pi-building"></i></p-inputGroupAddon>
                <p-iftalabel>
                    <p-select
                        inputId="crmClient"
                        [options]="clients"
                        [ngModel]="selectedClient"
                        optionLabel="companyName"
                        [filter]="true"
                        filterBy="companyName,clientNumber,primaryEmail,phoneNumber"
                        [virtualScroll]="true"
                        scrollHeight="260px"
                        [virtualScrollItemSize]="38"
                        [disabled]="disabled"
                        [placeholder]="clientPlaceholder"
                        appendTo="body"
                        styleClass="w-full"
                        (onChange)="selectedClientChange.emit($event.value)">
                    </p-select>
                    <label for="crmClient">{{ clientLabel }}</label>
                </p-iftalabel>
            </p-inputGroup>
            <small class="p-error" *ngIf="clientRequired && !selectedClient">{{ clientLabel }} is required.</small>
        </div>

        <div class="field">
            <p-inputGroup>
                <p-inputGroupAddon><i class="pi pi-user"></i></p-inputGroupAddon>
                <p-iftalabel>
                    <p-select
                        inputId="crmClientContact"
                        [options]="contacts"
                        [ngModel]="selectedContact"
                        optionLabel="name"
                        [filter]="true"
                        filterBy="name,email,phone,mobile,communicationType"
                        [showClear]="true"
                        [disabled]="disabled || !selectedClient"
                        [placeholder]="contactPlaceholder"
                        appendTo="body"
                        styleClass="w-full"
                        (onChange)="selectedContactChange.emit($event.value)">
                    </p-select>
                    <label for="crmClientContact">{{ contactLabel }}</label>
                </p-iftalabel>
            </p-inputGroup>
        </div>
    `,
    styles: [`
        :host {
            display: contents;
        }

        .field {
            min-width: 0;
        }

        .p-error {
            display: block;
            margin-top: 0.35rem;
        }

        :host ::ng-deep .p-inputgroup,
        :host ::ng-deep .p-iftalabel,
        :host ::ng-deep .p-select {
            width: 100%;
        }

        :host ::ng-deep .p-inputgroupaddon {
            width: 2.9rem;
            color: var(--app-accent-strong);
            background: var(--app-accent-surface);
            border-color: var(--app-border);
        }
    `]
})
export class CrmClientContactPickerComponent {
    @Input() clients: CrmClient[] = [];
    @Input() contacts: CrmClientCommunication[] = [];
    @Input() selectedClient: CrmClient | null = null;
    @Input() selectedContact: CrmClientCommunication | null = null;
    @Input() clientRequired = false;
    @Input() disabled = false;
    @Input() clientLabel = 'CRM Client';
    @Input() contactLabel = 'CRM Contact';
    @Input() clientPlaceholder = 'Select CRM client';
    @Input() contactPlaceholder = 'Select contact';

    @Output() selectedClientChange = new EventEmitter<CrmClient | null>();
    @Output() selectedContactChange = new EventEmitter<CrmClientCommunication | null>();
}
